import { AuthenticationService as IAuthenticationService } from "App/Contracts";

import AuthenticationService from "App/Externals/Services/Authentication";

const Authentication: IAuthenticationService = new AuthenticationService();

export default Authentication;
